<template>
  <div :style="info.id === -1 && { height: '100%' }" :class="[ thinnerCards.includes(this.$store.state.tab) && this.$lang === 'ar' ? 'wide-inner-card-investor investor-space-ar' : thinnerCards.includes(this.$store.state.tab) ? 'wide-inner-card-investor investor-space-en'  : wideCards.includes(this.$store.state.tab) && this.$lang === 'ar' ? 'social-space-ar'  : wideCards.includes(this.$store.state.tab)  ? 'social-space-en' : '' ,'wide-inner-card']">
    <Loader v-if="info.id === -1" />
    <div v-if="info.id !== -1">
      <div class="wide-inner-card-img-container">
        <img class="wide-inner-card-img" :src="info.img"/>
        <div v-if="cardType !== 'investor-relations'" :class="[this.$lang === 'ar' ? 'right-img-desc bold-italic-ar' : 'left-img-desc bold-italic-en' , 'wide-inner-card-img-desc']">{{info.imgDesc}}</div>
      </div>
      <div :class="[$store.state.tab === 3 && this.$lang === 'ar' ? 'flex-start' : '', 'wide-inner-card-info']">
        <div :class="this.$lang === 'ar' ? 'regular-ar' : 'regular-en'" class="wide-inner-card-time">{{info.time}}</div>
        <div v-if="cardType !== 'investor-relations'" @click="handleSharing" class="wide-inner-share-btn clickable"><img src="../../assets/icons/yellow-share-btn.svg"></div>
      </div>
      <div :class="[($store.state.tab === 3 && 'wide-inner-card-desc-investor'),(this.$lang === 'ar' ? 'regular-ar' : 'regular-en'), ($store.state.tab === 3 && this.$lang === 'ar' ? 'bold-italic-ar' : $store.state.tab === 3 ? 'bold-italic-en' : '') ,'wide-inner-card-desc']">
        {{info.desc}}
      </div>
      <div v-if="cardType === 'investor-relations'" class="pdf-file mt-3">
        <div class="clickable" :class="this.$lang === 'ar' ? 'regular-ar' : 'regular-en'">
          <div @click="downloadFile(info.fileId)"> {{$t('investorCard.pdfFile')}} </div>
        </div>
        <div><img src="../../assets/icons/pdf.svg"></div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import gc from '../../utils/gc'
import Loader from '../LoaderBtn/Loader'
export default {
  components: { Loader },
  props: { info: Object, cardType: String, Loader },
  data () {
    return {
      wideCards: [1, 2],
      thinnerCards: [3]
    }
  },
  mounted () {
    // console.log('info', this.info)
    // this.$watch(() => {
    //   return this.$store.state.tab
    // }, (val) => {
    //   console.log(val)
    // })
    setTimeout(() => {
      this.$lang === 'ar' ? $('.wide-card-img').css({ transform: 'rotateY(180deg)' }) : $('.wide-card-img').css({ transform: 'rotate(0deg)' })
      // this.$lang === 'ar' ? $('.wide-inner-card-img-desc').css({ right: '20px' }) : $('.wide-inner-card-img-desc').css({ left: '20px' }, { 'text-align': 'left' })
      this.$lang === 'ar' ? $('.wide-inner-card-img-desc').css('font-family', 'bold-italic-ar') : $('.wide-inner-card-img-desc').css('font-family', 'bold-italic-en')
      this.$lang === 'ar' ? $('.wide-inner-card-img-desc').css('text-align', 'right') : $('.wide-inner-card-img-desc').css('text-align', 'left')
      // this.$lang === 'ar' && this.$store.state.tab === 3 ? $('.wide-inner-card-info').css({ 'justify-content': 'flex-end' }) : $('.wide-inner-card-info').css({ 'justify-content': 'flex-start' })
      // this.$lang === 'ar' ? $('.wide-inner-card-info').css({ 'flex-direction': 'row-reverse' }) : $('.wide-inner-card-img-desc').css({ 'flex-direction': 'unset' })
      this.$lang === 'ar' ? $('.wide-inner-card-desc').css({ 'text-align': 'right' }, { 'font-family': 'Mtn-regular' }) : $('.wide-inner-card-desc').css({ 'text-align': 'left' }, { 'font-family': 'Mtn-arabic-regular' })
      // this.style()
    })
    window.addEventListener('resize', () => {
      // this.style()
    })
  },
  methods: {
    downloadFile (id) {
      const a = document.createElement('a')
      // // a.setAttribute('download', fileName)
      const url = `${gc.baseUrl}/customerCare/api/investor/download/${id}`
      a.download = 'file.pdf'
      a.href = url
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    handleSharing () {
      this.$store.state.sharedMessage = `${this.info.imgDesc} `
      this.$store.state.sharing = true
      if (this.info.type === 'social') {
        this.$store.state.sharingLink = `${gc.website}/news-details/${this.info.type}/${this.info.id}`
        // this.$store.state.sharedMessage = this.$lang === 'ar' ? `العنصر  ${this.info.imgDesc}` : `${this.info.imgDesc} item `
        this.$store.state.sharedTitle = this.$t('shareDialog.shareItem')
        this.$store.state.urlTitle = this.$t('shareDialog.social')
      } else if (this.info.type === 'news') {
        this.$store.state.sharingLink = `${gc.website}/news-details/${this.info.type}/${this.info.id}`
        // this.$store.state.sharedMessage = this.$lang === 'ar' ? `الخبر  ${this.info.imgDesc}` : `${this.info.imgDesc} news `
        this.$store.state.sharedTitle = this.$t('shareDialog.shareNews')
        this.$store.state.urlTitle = this.$t('shareDialog.news')
      }
    }
  }
}
</script>
<style lang="scss">
.clickable{
  pointer-events: all !important;
}
.wide-inner-card{
  position: absolute;
  top: 38px;
  width: 375px;
  margin: 0 auto;
  user-select: none;
}
.wide-inner-card-investor{
  width: 360px !important;
}
.social-space-en{
  left: calc(50% -  188px) !important;
}
.investor-space-en{
  left: calc(50% -  183px) !important;
}
.social-space-ar{
  right: calc(50% -  188px) !important;
}
.investor-space-ar{
  right: calc(50% -  183px) !important;
}
.wide-inner-card-img-container{
  width: 100%;
  height: 195px; //175
  margin: 0 auto;
  position: relative;
  user-select: none !important;
}
.wide-inner-card-img-desc{
  color: #FFCB05;
  position: absolute;
  bottom: 20px;
  width: 80%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
}
.right-img-desc{
  right: 20px;
  text-align: right;
}
.left-img-desc{
  left: 20px;
  text-align: left;
}
.wide-inner-card-img{
  width: 100%;
  height: 100%;
  border-radius: 20px;
  user-select: none;
  pointer-events: none;
}
.wide-inner-card-info{
  width: 98%;
  display: flex;
  justify-content: space-between;
  margin-top: .8rem;
}
.flex-start{
  justify-content: flex-start !important;
}
.flex-end {
  justify-content: flex-end !important;
}
.wide-inner-card-desc{
  margin-top: 1.8rem; // 2rem
  font-size: 15px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.wide-inner-card-desc-investor{
  font-family: 'Mtn-bold-italic';
  width: 85%;
  font-size: 18px;
  line-height: 1;
  //height: 89px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.pdf-file{
  display: flex;
  align-items: center;
}
.pdf-file div{
  margin: 0 5px;
  text-decoration: underline;
  cursor: pointer;
}
.wide-inner-share-btn{
  cursor: pointer;
}
@media (max-width: 550px) {
  .wide-inner-card{
    top: 33px;
  }
  .wide-card-container,
  .wide-inner-card{
    width: 318px;
  }
  .wide-inner-card-investor{
    width: 312px !important;
  }
  .wide-inner-card-desc-investor{
    width: 100%;
  }
  .wide-inner-card-img-container{
    height: 160px; //135
  }
  .wide-inner-card-img{
    border-radius: 12px;
  }
  .wide-inner-card-btn{
    width: 50px;
    height: 50px;
  }
  .wide-inner-card-info{
    margin-top: .5rem;
  }
  .wide-inner-card-desc {
    margin-top: 1rem;
    //-webkit-line-clamp: 3;
  }
  .wide-inner-card-img-desc {
    color: #FFCB05;
    position: absolute;
    bottom: 10px;
    width: 100%;
    font-size: 14px;
    -webkit-line-clamp: 5;
  }
  .pdf-file{
    padding: 20px 0 0 0;
    display: flex;
    align-items: center;
  }
  .social-space-en{
    left: calc(50% -  160px) !important;
  }
  .investor-space-en{
    left: calc(50% -  157px) !important;
  }
  .social-space-ar{
    right: calc(50% -  160px) !important;
  }
  .investor-space-ar{
    right: calc(50% -  157px) !important;
  }
  .right-img-desc{
    right: 8px;
  }
  .left-img-desc{
    left: 8px;
  }
}
@media (max-width: 400px) {
  .wide-inner-card-img-container{
    height: 125px;
  }
  .wide-inner-card-img-desc{
    -webkit-line-clamp: 3;
  }
  .wide-inner-card-desc-investor{
    font-size: 15px;
  }
  .wide-card-container,
  .wide-inner-card{
    width: 282px;
    top: 32px
  }
  .wide-inner-card-investor{
    width: 277px !important;
  }
  .wide-inner-card-img-desc {
    width: 98% !important;
  }
  .pdf-file{
    padding: 5px 0 0 0;
  }
  .social-space-en{
    left: calc(50% -  142px) !important;
  }
  .investor-space-en{
    left: calc(50% -  139px) !important;
  }
  .social-space-ar{
    right: calc(50% -  142px) !important;
  }
  .investor-space-ar{
    right: calc(50% -  139px) !important;
  }
}
</style>
